var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-basis: 49%;\n  margin-bottom: 30px;\n  border-radius: 0;\n  border: none;\n\n  @media(max-width: 767px){\n    flex-basis: 100%;\n  }\n'], ['\n  display: flex;\n  flex-basis: 49%;\n  margin-bottom: 30px;\n  border-radius: 0;\n  border: none;\n\n  @media(max-width: 767px){\n    flex-basis: 100%;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  color: white;\n  text-align: center;\n  font-family: ', ';\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: -0.14px;\n  line-height: 22px;\n  \n  &.solid-header {\n    border-radius: 0;\n  }\n'], ['\n  background-color: ', ';\n  color: white;\n  text-align: center;\n  font-family: ', ';\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: -0.14px;\n  line-height: 22px;\n  \n  &.solid-header {\n    border-radius: 0;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { Card, CardHeader, CardBody } from 'reactstrap';
import Theme from '../../Theme';

export var HeadedBoard = styled(Card)(_templateObject);

export var SolidHeader = styled(CardHeader).attrs({
  className: 'solid-header'
})(_templateObject2, function (_ref) {
  var headerBkg = _ref.headerBkg;
  return headerBkg;
}, Theme.fonts.Montserrat);

export default (function (_ref2) {
  var header = _ref2.header,
      children = _ref2.children,
      headerBkg = _ref2.headerBkg;
  return React.createElement(
    HeadedBoard,
    null,
    React.createElement(
      SolidHeader,
      { headerBkg: headerBkg },
      header
    ),
    React.createElement(
      CardBody,
      null,
      children
    )
  );
});